const urlName = '/order/v1';

export default (API) => ({
   // 优惠券列表
    getCouponList(data) {
        return API({
            url: `${urlName}/open/entityGoods/detail`,
            data,
            method: 'post',
        });
    },
    // 领取优惠券
    getCoupon(data) {
        return API({
            url: `${urlName}/open/entityGoods/detail`,
            data,
        });
    },
    // 使用优惠券
    useCoupon(data) {
        return API({
            url: `${urlName}/open/entityGoods/detail`,
            data,
        });
    },
    // 优惠券可用商品列表
    couponGoodsList(params) {
        return API({
            url: `/marketing-mix/v1/couponGoods/availableGoodsList`,
            params,
        });
    },
    couponAllGoodsList(data,params) {
        return API({
            url: `/order/v1/saleSystem/distributionGoods/mall/channelGoodsList`,
            data,
            params,
            method: 'post',
        });
    }

});
